export default "__VITE_PUBLIC_ASSET__89242455__"